import React from "react";
import PrivacyPolicy from "../components/otherPageComponent/PrivacyPolicy";
import SEO from "../components/SEO";

const PrivacyPolicyPage = () => {
  return (
    <>
      <SEO
        title="Privacy Policy - Aastha Computers"
        description="Read the Privacy Policy of Aastha Computes, Bikaner. Learn how we protect your personal information and ensure your data privacy while you learn with us."
        pagePath="/privacy-policy"
      />
      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;
